import { Button } from 'cwp-components/forms'

export const VerificationError = ({ setStatus }) => {
  return (
    <div className='md:p-[60px] md:w-[900px] w-full md:h-[500px]  p-[20px] md:m-auto bg-white rounded-[20px]'>
      <div className='md:p-[30px] p-[10px]'>
        <h1 className='md:text-[24px] md:mb-[50px] mb-[20px] text-[16px] text-[#093269] font-bold '>
          ID verification
        </h1>
        <div className='flex items-start gap-[7px]'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='25'
            viewBox='0 0 24 25'
            fill='none'
          >
            <path
              fill-rule='evenodd'
              clip-rule='evenodd'
              d='M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5ZM17.1536 7.34678C17.3488 7.54204 17.3488 7.85863 17.1536 8.05389L12.7071 12.5003L17.1536 16.9468C17.3488 17.142 17.3488 17.4586 17.1536 17.6539C16.9583 17.8491 16.6417 17.8491 16.4465 17.6539L12 13.2074L7.55357 17.6539C7.35831 17.8491 7.04173 17.8491 6.84647 17.6539C6.65121 17.4586 6.65121 17.142 6.84647 16.9468L11.2929 12.5003L6.84647 8.05389C6.65121 7.85863 6.65121 7.54204 6.84647 7.34678C7.04173 7.15152 7.35831 7.15152 7.55357 7.34678L12 11.7932L16.4465 7.34678C16.6417 7.15152 16.9583 7.15152 17.1536 7.34678Z'
              fill='#DE3333'
            />
          </svg>
          <div className='space-y-[13px] md:mb-[70px] mb-[30px]'>
            <h1 className='md:text-[18px] text-[14px] font-bold '>
              Your verification has been unsuccessful
            </h1>
            <p className='md:text-[16px] text-[12px] font-[400] '>
              YOTI was unable to complete your ID verification on this occasion.
              You can opt to try again or contact support to look into the
              issue.
            </p>
          </div>
        </div>
        <div className='flex justify-end gap-[20px]'>
          <Button className='text-[#1C7D93]'>Label</Button>
          <Button
            onClick={() => setStatus('default')}
            className='bg-[#020251] text-white'
          >
            Try again
          </Button>
        </div>
      </div>
    </div>
  )
}
